import ExportIcon from "@mui/icons-material/OutputRounded";
import FilterIcon from "@mui/icons-material/FilterListRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";

interface Props {
  disabled?: boolean;
  loading?: boolean;
  onExportAllRecords: () => void;
  onExportFilteredRecords: () => void;
}

const ExportWithFiltersButton = ({ disabled, loading, onExportAllRecords, onExportFilteredRecords }: Props) => {
  return (
    <ActionsMenuButton
      text="Export to Excel"
      variant="outlined"
      color="secondary"
      icon={<ExportIcon />}
      disabled={disabled}
      loading={loading}
      items={[
        {
          label: "All records",
          icon: <ExportIcon />,
          onClick: onExportAllRecords,
        },
        {
          label: "Only filtered records",
          icon: <FilterIcon />,
          onClick: onExportFilteredRecords,
        },
      ]}
    />
  );
};

export default ExportWithFiltersButton;
